import React, { Component } from 'react';
import AccountMenu from '../Modules/AccountMenu'
import { LinkContainer } from 'react-router-bootstrap'

import UwGegevens from '../Modules/Account/UwGegevens'
import ContactGegevens from '../Modules/Account/ContactGegevens'
import BedrijfsGegevens from '../Modules/Account/BedrijfsGegevens'
import FactuurAdres from '../Modules/Account/FactuurAdres'
import Overig from '../Modules/Account/Overig'
import { Button, Form, Row, Col } from 'react-bootstrap';
import Api from './../../Global/Modules/Api'

const MATERIALS = "materials"
const SHOW_COUNTRY = "showCountry"
const SHOW_COMPANY_COUNTRY = "showCompanyCountry"

//const JSON_FILE = require('./../Modules/Account/account.json')
const FETCH_URL = "api/members/account/"

class AccountBeheren extends Component {

    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleWorkAreasChange = this.handleWorkAreasChange.bind(this)
        this.state = {
            data: {},
            materials: {},
            errors: {}
        }
    }

    componentDidMount() {
        Api.GetApi(FETCH_URL).then(response => {
            this.setState({
                data: response.member,
                materials: response.materials
            })

        })
        // Example of usage
        Api.print(
            `Admin? ${Api.isAdmin()}
            Member role? ${Api.hasMemberRole()}
            Admin role? ${Api.hasAdminRole()}
            Secretary management role? ${Api.hasSecretaryManagementRole()}
            Secretary view role: ${Api.hasSecretaryViewRole()}
            Roles: 
            ${Api.hasRole("member_role")} 
            ${Api.hasRole("admin_role")}
            ${Api.hasRole("secretary_management_role")}
            ${Api.hasRole("secretary_view_role")} `
        )
    }


    // Function that will be executed when something in the form changes
    handleChange(name, value) {
        if (name === SHOW_COUNTRY && value)
            this.setState({ data: { ...this.state.data, country: 1 } })
        else if (name === SHOW_COUNTRY && !value)
            this.setState({ data: { ...this.state.data, country: null } })
        else if (name === SHOW_COMPANY_COUNTRY && value)
            this.setState({ data: { ...this.state.data, companyCountry: 1 } })
        else if (name === SHOW_COMPANY_COUNTRY && !value)
            this.setState({ data: { ...this.state.data, companyCountry: null } })
        else
            this.setState({ data: { ...this.state.data, [name]: value } })
    }

    // Function that will be executed when work areas array changes
    handleWorkAreasChange(index, value) {
        let materialsChecked = Object.assign([], this.state.data[MATERIALS])
        Api.print(`${index}: ${value}`)
        if (value) materialsChecked.push(parseInt(index))
        else {
            let newMaterialsChecked = []
            materialsChecked.forEach(materialIndex => {
                if (materialIndex !== index) newMaterialsChecked.push(materialIndex)
            })

            materialsChecked = newMaterialsChecked
        }
        this.setState({ data: { ...this.state.data, [MATERIALS]: materialsChecked } })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        // TODO: Post this.state.data to the API
        Api.print("Sending json...")

        Api.PostApi(FETCH_URL, this.state.data, this.props.history)
            .then(data => {
                alert("Account Updated")
            })
    }

    render() {
        let errors = this.state.errors
        let data = this.state.data
        let materials = this.state.materials

        return (
            <div className="route account">
                <AccountMenu />
                <div className="grey-bg">
                    <h1 className="pageTitle">
                        Account beheren
                    </h1>
                    <p>Verplichte invoervelden zijn aangeduid met *.</p>
                    <p>Iedere invoer dient u te bevestigen door te klikken op Opslaan.</p>
                    <p className="text-right">
                        <LinkContainer to="/account/wachtwoord-wijzigen"><Button>Wachtwoord wijzigen</Button></LinkContainer>
                    </p>
                </div>
                <Form horizontal onSubmit={this.handleSubmit} className="accountBeherenHolder">
                    <Row>
                        <Col md={6}>
                            <div className="grey-bg">
                                <UwGegevens onChange={this.handleChange} errors={errors} data={data} />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="grey-bg">
                                <ContactGegevens onChange={this.handleChange} errors={errors} data={data} />
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <div className="grey-bg">
                                <BedrijfsGegevens onChange={this.handleChange} errors={errors} data={data} />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="grey-bg">
                                <Overig onChange={this.handleChange} onWorkAreasChange={this.handleWorkAreasChange} data={data} materials={materials} />
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <div className="grey-bg">
                                <FactuurAdres data={data} />
                            </div>
                        </Col>
                        {/**<Col md={6}>
                            <div className="grey-bg">
                                <AccountGegevens onChange={this.handleChange} errors={errors} data={data} />
                            </div>
                        </Col>**/}
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="grey-bg">
                                <Button type="submit" name="submitButton">Opslaan</Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

export default AccountBeheren;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/AccountBeheren.js